import styled from 'styled-components';

const StyledCheckbox = styled.div`
  color: ${({ theme }): string => theme.fontColour};
  font-family: 'Lato';
  margin-bottom: 1em;
`;

StyledCheckbox.defaultProps = {
  theme: {
    fontColour: '#000000',
  },
};

export default StyledCheckbox;
